module.exports = __webpack_public_path__ + "6e7ed6.png";